export const MUL_QUERY_KEY = 'useUnitType';
